import React from "react";

import { useTranslations } from "next-intl";
import boldMatch from "../../common/utils/boldMatch";
import { Link } from "../../../navigation";
import MigelConformity from "../../shop/components/MigelConformity";
import Image from "next/image";
import ProductAvailability from "../../shop/components/ProductAvailability";
import getAvailability from "../../shop/utils/getAvailability";
import DOMRenderer from "../../cms/components/DOMRenderer";

const SuggestedProductListItem = ({
  product,
  searchTerm,
  showMigelConformity,
  shouldUseInstitutionalMigelConformity = true,
}) => {
  const t = useTranslations();

  const migelConformity = shouldUseInstitutionalMigelConformity
    ? product?.publicare?.institutionalMigelConformity
    : product?.publicare?.clientMigelConformity;

  const { availability, earliestDeliveryDate } = getAvailability({
    stocks: product?.simulatedStocks,
    dispatches: product?.simulatedDispatches,
  });
  const { media } = product;
  const cover = media?.[0];
  return (
    <Link
      aria-label="product suggestion"
      key={product?._id}
      href={`/product/${product?.texts?.slug}`}
      className="searched-item py-2 py-md-1 d-flex align-items-center justify-content-start gap-2 flex-no-wrap w-100 mb-2"
    >
      <>
        {cover?.file?.small && (
          <Image
            src={cover?.file?.small}
            unoptimized
            alt=""
            width={80}
            height={80}
            priority={false}
          />
        )}
        <div className="d-flex justify-content-between align-items-end row w-100">
          <div className="col-sm-8 align-self-center cursor-pointer">
            <DOMRenderer
              htmlString={boldMatch({
                value: product?.texts?.title,
                highlight: searchTerm,
              })}
            />
            <div className="fs-8 mt-1">
              {t("article_number_label")}
              :&nbsp;
              {product.sku}
            </div>
            <div className="fs-7 mt-1">
              {showMigelConformity && (
                <MigelConformity migelConformity={migelConformity} />
              )}
            </div>
          </div>
          <div className="col-sm-4 mt-2">
            <ProductAvailability
              availability={availability}
              earliestDeliveryDate={earliestDeliveryDate}
            />
          </div>
        </div>
      </>
    </Link>
  );
};

export default React.memo(SuggestedProductListItem);
